var map = {
	"./de.json": [
		2004,
		77
	],
	"./de_CH.json": [
		2005,
		78
	],
	"./de_DE.json": [
		2006,
		79
	],
	"./en.json": [
		704
	],
	"./en_CA.json": [
		2007,
		2
	],
	"./en_CH.json": [
		2008,
		2
	],
	"./en_GB.json": [
		2009,
		4
	],
	"./en_ZA.json": [
		1963,
		5
	],
	"./fr.json": [
		2010,
		80
	],
	"./fr_CA.json": [
		2011,
		4
	],
	"./fr_CH.json": [
		2012,
		4
	],
	"./it.json": [
		2013,
		81
	],
	"./it_CH.json": [
		2014,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 836;
module.exports = webpackAsyncContext;